const TRACK_NAME = '[features-manager]';

export const trackEvent = (eventName, props = {}) => {
  window.analytics.track(
    `${TRACK_NAME} ${eventName}`,
    {
      appName: 'Features Manager',
      screen: {
        width: window.innerWidth,
        height: window.innerHeight,
      },
      ...props,
    },
    {
      integrations: {
        // we don't want to send all events to Intercom
        Intercom: false,
      },
    }
  );
};

export const identify = user => {
  const identifyOptions = {
    Intercom: {
      hideDefaultLauncher: true,
    },
  };

  window.analytics.identify(
    user.user_id,
    {
      email: user.email,
      userId: user.user_id,
      organizationId: user.organization_id,
      programId: user.program_id,
      roleLevel: user.role_level,
    },
    identifyOptions,
    () => {
      trackEvent('Logged In');
    }
  );
};

export const reset = () => analytics.reset();
